import { InvokeMethodExpr, splitClasses } from "@angular/compiler";
import { Component, IterableDiffers, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { element } from "protractor";
import { SubscriptionService } from "src/app/core/services/subscription.service";
import {Location} from '@angular/common';

@Component({
  selector: "subscription",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./subscription.component.scss"],
})
export class SubscriptionComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  public subscriptionForm: FormGroup;
  public currentUser = JSON.parse(localStorage.getItem("currentUser"));
  public featuresArray: any;
  public featureData: number;
  public total = 0;
  public isActive = false;
  public features = [];
  public pseudoArray = [];
  public plans: any;
  public trailPlan: any;
  public basicPlanIdTwo: any;
  public notSelectedDay: boolean = false;
  public basicPlanIdThree: any;
  public basicPlanIdFour: any;
  public premiumPlanIdFive: any;
  public premiumPlanIdSix: any;
  public premiumPlanIdSeven: any;
  public basicId: any;
  public premiumId: any;
  public featureLength: any;
  public trialPlanId: any;
  public id: any;
  public array = [];
  public BasicPlanArrayTwo: any;
  public BasicPlanArrayThree: any;
  public BasicPlanArrayFour: any;
  public premiumPlanArrayFive: any;
  public premiumPlanArraySix: any;
  public premiumPlanArraySeven: any;
  public idTwo = false;
  public idThree = false;
  public idFour = false;
  public idFive = false;
  public idSix = false;
  public idSeven = false;
  public checkStat = false;
  public planDays: any;
  public checked: boolean = true;
  public grandTotal  : any ;
  public isShowPlan :boolean = true;
  public newPlans: any

  constructor(
    public subscriptionService: SubscriptionService,
    public fb: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    public _location: Location
  ) { }

  ngOnInit(): void {
    this.getAllSubscriptionPlans();
    this.getAllSubscriptionFeatures();
    // this.getBasicPlanFetaureIdTwo(2);
    // this.getPremiumPlanFetaureIdFive(5);


    //form for modal
    this.subscriptionForm = this.fb.group({
      //   grandTotal:["",this.total],
      Rows: this.fb.array([]),
    });

  }

  /**
   * Get FormArray controls
   */
  get formArray() {
    return this.subscriptionForm.get("Rows") as FormArray;
  }

  addNewRow() {
    const content = this.subscriptionForm.get("Rows") as FormArray;
    content.push(this.initRows());
  }

  initRows(): FormGroup {
    return new FormGroup({
      featureName: new FormControl(),
      price: new FormControl(),
      featureId: new FormControl(),
      active: new FormControl(),
    });
  }

  /**
   * Get All Subscription Features
   */
  getAllSubscriptionFeatures() {
    this.isActive = true;
    this.subscriptionService.getFeatures({}, this.currentUser.id).then((res) => {
      this.featuresArray = res.data;
      // this.findTotal(this.featuresArray);
      if (res.data != null) {
        if (res.data.length > 0) {
          res.data.forEach((element, index) => {
            this.addNewRow();
            this.formArray.controls[index].patchValue({
              featureName:
                element.displayName.charAt(0).toUpperCase() +
                element.displayName.substr(1).toLowerCase(),
              price: element.price,
              featureId: element.id
            });
          });
        }
      }
    });
  }

  /**
   * get all main plans
   */
  getAllSubscriptionPlans() {
    this.subscriptionService.getPlans({}).then((res) => {
      this.newPlans=res.data
      console.log("this.newplans",this.newPlans)
      // this.trialPlanId = +res.data
      //   .filter((x, index) => index == 0)
      //   .map((x) => x.id)
      //   .join();
      // this.basicPlanIdTwo = +res.data
      //   .filter((x, index) => index == 1)
      //   .map((x) => x.id)
      //   .join();
      // this.basicPlanIdThree = +res.data
      //   .filter((x, index) => index == 2)
      //   .map((x) => x.id)
      //   .join();
      // this.basicPlanIdFour = +res.data
      //   .filter((x, index) => index == 3)
      //   .map((x) => x.id)
      //   .join();
      // this.premiumPlanIdFive = +res.data
      //   .filter((x, index) => index == 4)
      //   .map((x) => x.id)
      //   .join();
      // this.premiumPlanIdSix = +res.data
      //   .filter((x, index) => index == 5)
      //   .map((x) => x.id)
      //   .join();
      // this.premiumPlanIdSeven = +res.data
      //   .filter((x, index) => index == 6)
      //   .map((x) => x.id)
      //   .join();
      // this.getTrialPlanFetaure(this.trialPlanId);
      // this.getBasicPlanFetaureIdTwo(this.basicPlanIdTwo);
      // this.getBasicPlanFetaureIdThree(this.basicPlanIdThree);
      // this.getBasicPlanFetaureIdFour(this.basicPlanIdFour);
      // this.getPremiumPlanFetaureIdFive(this.premiumPlanIdFive);
      // this.getPremiumPlanFetaureIdSix(this.premiumPlanIdSix);
      // this.getPremiumPlanFetaureIdSeven(this.premiumPlanIdSeven);
      //this.planId=id;
      // console.log("trailPlanId", this.trialPlanId);
      // console.log("basicPlanIdTwo", this.basicPlanIdTwo);
      // console.log("basicPlanIdThree", this.basicPlanIdThree);
      // console.log("basicPlanIdFour", this.basicPlanIdFour);
      // console.log("premiumPlanIdFive", this.premiumPlanIdFive);
      // console.log("premiumPlanIdSix", this.premiumPlanIdSix);
      // console.log("premiumPlanIdSeven", this.premiumPlanIdSeven);
    });
  }

  /**
   * get trial plan feature by id
   * @param trialPlanId 
   */
  // getTrialPlanFetaure(trialPlanId) {
  //   this.subscriptionService.getFetaureById({}, trialPlanId).then((res) => {
  //     this.isShowPlan = false;
  //     this.trailPlan = res.data;
  //   });
  // }

 

  /**
   * post subscribe basic plan with 90 days
   */
  basicPostSubscription() {
    console.log("matchingPlan22222")
    let matchingPlan = this.newPlans.find(element => element.planLevel === 1);
    console.log("matchingPlan",matchingPlan)
    let data = {
      "subscriptionPlanId": matchingPlan.id,
      "userId": this.currentUser.id,
    };
    
    this.subscriptionService.basicSubsription(data).then((res) => {
      this.router.navigate([`auth/payment-subscription/${matchingPlan.id}/${res.data.subscriptionPaymentId}/${res.data.userSubscriptionId}`])
    });


  }
  /**
   * Get Radio button values according to days
   * @param days 
   */
  getPremiumPackDays(days) {
    this.premiumId = days;
    if (days == 5) {
      this.grandTotal = 0;
      this.planDays = "90Days";
      this.grandTotal = 3 * this.total;
    }
    else if (days == 6) {
      this.grandTotal = 0;
      this.planDays = "180Days";
      this.grandTotal = 6 * this.total;
    }
    else if (days == 7) {
      this.grandTotal = 0;
      this.planDays = "365days";
      this.grandTotal = (365 / 30 * this.total).toFixed(2);
    }
  }

  /**
   * Get checkbox value total accoridng to selected features
   * @param item 
   * @param event 
   * @param i 
   */
  onCheckChange(item, event: boolean, i) {
    console.log("event called",item)
    if (event) {
      var index = this.pseudoArray.indexOf(item.featureId);
      if (index == -1) {
        this.pseudoArray.push(item.featureId)
      }
      if (this.premiumId == 5) {
        this.total += item.price;
        //this.planDays = "90Days";
        this.grandTotal = 3 * this.total;
      }
      else if (this.premiumId == 6) {
        this.total += item.price;
        this.grandTotal = 0;
        this.planDays = "180Days";
        this.grandTotal = 6 * this.total;
      }
      else if (this.premiumId == 7) {
        this.total += item.price;
        this.grandTotal = 0;
        this.planDays = "365days";
        this.grandTotal = (365 / 30 * this.total).toFixed(2);
      } else {
        this.total += item.price;
      }
    }
    else if (!event) {
      var index = this.pseudoArray.indexOf(item.featureId);
      if (index !== -1) {
        this.pseudoArray.splice(index, 1);
      }
      if (this.premiumId == 5) {
        this.total -= item.price;
        //this.planDays = "90Days";
        this.grandTotal = 3 * this.total;
      }
      else if (this.premiumId == 6) {
        this.total -= item.price;
        this.grandTotal = 0;
        this.planDays = "180Days";
        this.grandTotal = 6 * this.total;
      }
      else if (this.premiumId == 7) {
        this.total -= item.price;
        this.grandTotal = 0;
        this.planDays = "365days";
        this.grandTotal = (365 / 30 * this.total).toFixed(2);
      } else {
        this.total -= item.price;
      }
    }
    this.grandTotal= this.total

  }

  /**
   * Post customer premium plan details
   */
  premiumPostSubscription() {
    console.log("matchingPlanmatchingPlan33")
    let array = []
    let matchingPlan = this.newPlans.find(element => element.planLevel === 2);
    console.log("matchingPlanmatchingPlan33",matchingPlan)
    this.featuresArray.map((x) => {
      array.push(x.id)
    })
    let data = {
      "subscriptionPlanId": matchingPlan.id,
      "userId": this.currentUser.id,
      "featureId": array,
      "amount": "100"
    }
    // console.log("premiumId: " + this.premiumId)
    this.subscriptionService.premiumSubscription(data).then((res) => {
      // this.closebutton.nativeElement.click();
      //this.router.navigate([`auth/payment-subscription/${this.premiumId}`])
      this.router.navigate([`auth/payment-subscription/${matchingPlan.id}/${res.data.subscriptionPaymentId}/${res.data.userSubscriptionId}`])
    })

    
  }
  goTOBack(){
    this._location.back();
  
  }
}
